'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propValidators = exports.propAliases = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCss = require('../get-css');

var _getCss2 = _interopRequireDefault(_getCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  transform: _propTypes2.default.string,
  transformOrigin: _propTypes2.default.string
};

var propAliases = exports.propAliases = {};

var propValidators = exports.propValidators = {};

var _transform = {
  className: 'tfrm',
  cssName: 'transform',
  jsName: 'transform',
  complexValue: true
};
var _transformOrigin = {
  className: 'tfrm-orgn',
  cssName: 'transform-origin',
  jsName: 'transformOrigin',
  complexValue: true
};

var propEnhancers = exports.propEnhancers = {
  transform: function transform(value) {
    return (0, _getCss2.default)(_transform, value);
  },
  transformOrigin: function transformOrigin(value) {
    return (0, _getCss2.default)(_transformOrigin, value);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbmhhbmNlcnMvdHJhbnNmb3JtLmpzIl0sIm5hbWVzIjpbInByb3BUeXBlcyIsInRyYW5zZm9ybSIsIlByb3BUeXBlcyIsInN0cmluZyIsInRyYW5zZm9ybU9yaWdpbiIsInByb3BBbGlhc2VzIiwicHJvcFZhbGlkYXRvcnMiLCJjbGFzc05hbWUiLCJjc3NOYW1lIiwianNOYW1lIiwiY29tcGxleFZhbHVlIiwicHJvcEVuaGFuY2VycyIsInZhbHVlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFDQTs7Ozs7O0FBRU8sSUFBTUEsZ0NBQVk7QUFDdkJDLGFBQVdDLG9CQUFVQyxNQURFO0FBRXZCQyxtQkFBaUJGLG9CQUFVQztBQUZKLENBQWxCOztBQUtBLElBQU1FLG9DQUFjLEVBQXBCOztBQUVBLElBQU1DLDBDQUFpQixFQUF2Qjs7QUFFUCxJQUFNTCxhQUFZO0FBQ2hCTSxhQUFXLE1BREs7QUFFaEJDLFdBQVMsV0FGTztBQUdoQkMsVUFBUSxXQUhRO0FBSWhCQyxnQkFBYztBQUpFLENBQWxCO0FBTUEsSUFBTU4sbUJBQWtCO0FBQ3RCRyxhQUFXLFdBRFc7QUFFdEJDLFdBQVMsa0JBRmE7QUFHdEJDLFVBQVEsaUJBSGM7QUFJdEJDLGdCQUFjO0FBSlEsQ0FBeEI7O0FBT08sSUFBTUMsd0NBQWdCO0FBQzNCVixhQUFXO0FBQUEsV0FBUyxzQkFBT0EsVUFBUCxFQUFrQlcsS0FBbEIsQ0FBVDtBQUFBLEdBRGdCO0FBRTNCUixtQkFBaUI7QUFBQSxXQUFTLHNCQUFPQSxnQkFBUCxFQUF3QlEsS0FBeEIsQ0FBVDtBQUFBO0FBRlUsQ0FBdEIiLCJmaWxlIjoidHJhbnNmb3JtLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IGdldENzcyBmcm9tICcuLi9nZXQtY3NzJ1xuXG5leHBvcnQgY29uc3QgcHJvcFR5cGVzID0ge1xuICB0cmFuc2Zvcm06IFByb3BUeXBlcy5zdHJpbmcsXG4gIHRyYW5zZm9ybU9yaWdpbjogUHJvcFR5cGVzLnN0cmluZ1xufVxuXG5leHBvcnQgY29uc3QgcHJvcEFsaWFzZXMgPSB7fVxuXG5leHBvcnQgY29uc3QgcHJvcFZhbGlkYXRvcnMgPSB7fVxuXG5jb25zdCB0cmFuc2Zvcm0gPSB7XG4gIGNsYXNzTmFtZTogJ3Rmcm0nLFxuICBjc3NOYW1lOiAndHJhbnNmb3JtJyxcbiAganNOYW1lOiAndHJhbnNmb3JtJyxcbiAgY29tcGxleFZhbHVlOiB0cnVlXG59XG5jb25zdCB0cmFuc2Zvcm1PcmlnaW4gPSB7XG4gIGNsYXNzTmFtZTogJ3Rmcm0tb3JnbicsXG4gIGNzc05hbWU6ICd0cmFuc2Zvcm0tb3JpZ2luJyxcbiAganNOYW1lOiAndHJhbnNmb3JtT3JpZ2luJyxcbiAgY29tcGxleFZhbHVlOiB0cnVlXG59XG5cbmV4cG9ydCBjb25zdCBwcm9wRW5oYW5jZXJzID0ge1xuICB0cmFuc2Zvcm06IHZhbHVlID0+IGdldENzcyh0cmFuc2Zvcm0sIHZhbHVlKSxcbiAgdHJhbnNmb3JtT3JpZ2luOiB2YWx1ZSA9PiBnZXRDc3ModHJhbnNmb3JtT3JpZ2luLCB2YWx1ZSlcbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/ui-box/lib/enhancers/transform.js
// module id = 345
// module chunks = 0